module.exports = __webpack_public_path__ + "static/media/STEPS-1 Zulassungsstudie_Jeppesen PB, et al. Gastroenterology. 2012;143.9ccba0b4.pdf";